module.exports = __webpack_public_path__ + "img/logoWhite.1e3452de.svg";